import { render } from "./InspectionItemForm.vue?vue&type=template&id=9ab2d948"
import script from "./InspectionItemForm.vue?vue&type=script&lang=js"
export * from "./InspectionItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__